import 'js/src/libs/set-webpack-nonce';
import 'js/src/libs/page-initialization';

import 'css/src/global';

import React from 'react';

import { Urls } from 'js/src/client';
import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import CareerOpportunity from 'js/src/components/public-pages/careers/CareerOpportunity';
import CareersListings from 'js/src/components/public-pages/careers/CareersListings';
import CareersOverview from 'js/src/components/public-pages/careers/CareersOverview';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { renderComponent } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const CareersPage = React.memo(function CareersPage() {
    let content = <CareersOverview />;
    if (window.location.pathname.indexOf(Urls.CAREER_OPPORTUNITY) === 0) {
        content = <CareerOpportunity />;
    } else if (window.location.pathname.indexOf(Urls.CAREER_LISTINGS) === 0) {
        content = <CareersListings />;
    }
    return <PublicPagesTrim headerBackgroundColor="white">{content}</PublicPagesTrim>;
});

renderComponent(CareersPage);
